import React, { useState, useCallback, ChangeEvent, useEffect } from 'react';
import { Container, InputGroup, Button, ProgressBar } from 'react-bootstrap';

import { merge } from './apis';

import { MergeInputs } from 'orbus-uploader-client';
import { Socket } from 'socket.io-client';

interface MergeProps {
	socket: Socket;
}

export default function Merge(props: MergeProps) {
	const { socket } = props;
	const [paths, setPaths] = useState<Array<string>>([]);

	const setInputGenerator = useCallback(
		(index: number) => (e: ChangeEvent<HTMLInputElement>) => {
			const value = e.currentTarget.value;
			setPaths(currInputs => {
				currInputs[index] = value;
				return [...currInputs];
			});
		},
		[]
	);

	const addInput = useCallback(
		() =>
			setPaths(currInputs => {
				currInputs.push('');
				return [...currInputs];
			}),
		[]
	);

	// TODO - update Merge API call here in demo FE to use the API key header...?

	const [state, setState] = useState<null | number | [string, string[]]>(null);

	useEffect(() => {
		const progressHandler = (_: string, progress: number) => setState(progress);
		const completeHandler = (jobId: string, files: string[]) =>
			setState([jobId, files]);

		socket.on('merge-complete', completeHandler);
		socket.on('merge-progress', progressHandler);
		return () => {
			socket.off('merge-complete', completeHandler);
			socket.off('merge-progress', progressHandler);
		};
	}, [socket]);

	const startMerge = useCallback(() => {
		const inputs = paths.map(path => ({ path, range: '1' }));
		const body: MergeInputs = { inputs };
		void merge.merge(body).then(response => {
			socket.emit('merge-watch', response.jobId);
			socket.on('connect', () => {
				socket.emit('merge-watch', response.jobId);
			});
			setState(0);
		});
	}, [paths, socket]);

	let display;
	if (state === null)
		display = (
			<>
				<p>
					Add paths in <code>s3://bucket/key</code> format.
				</p>
				{paths.map((value, index) => {
					return (
						<React.Fragment key={index}>
							<label>{index + 1}:</label>
							<InputGroup>
								<input
									className="form-control"
									value={value}
									onChange={setInputGenerator(index)}
								></input>
							</InputGroup>
						</React.Fragment>
					);
				})}
				<Button onClick={addInput}>Add path</Button>
				<br />
				<Button onClick={startMerge}>Merge</Button>
			</>
		);
	else if (typeof state === 'number')
		display = (
			<ProgressBar
				animated
				label={`${Math.round(state * 100)}%`}
				now={Math.round(state * 100)}
				variant="success"
			/>
		);
	else if (Array.isArray(state))
		display = (
			<ul>
				{state[1].map((file, index) => (
					<li key={index}>
						<a
							download
							target="_blank"
							rel="noopener noreferrer"
							href={`/api/merge/download/${state[0]}/merged.pdf`}
						>
							{file}
						</a>
					</li>
				))}
			</ul>
		);

	return <Container>{display}</Container>;
}
